import { useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const ReassignDialog = ({ open, onOpenChange, lead, sellers, onDone }) => {
  const [sellerId, setSellerId] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const isAssign = !lead.assigned_seller_id;

  const save = async () => {
    setSaving(true);
    setError("");
    try {
      await api.post(`/leads/${lead.id}/reassign`, { seller_id: sellerId });
      toast.success(isAssign ? "Lead asignado" : "Lead reasignado");
      setSellerId("");
      onOpenChange(false);
      onDone();
    } catch (e) { setError(errorMessage(e)); } finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { setError(""); onOpenChange(o); }}>
      <DialogContent className="rounded-2xl sm:max-w-md" data-testid="reassign-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl font-extrabold">{isAssign ? "Asignar lead" : "Reasignar lead"}</DialogTitle>
          <DialogDescription>
            {isAssign ? "Este lead está sin asignar." : `Vendedor actual: ${lead.assigned_seller_name}.`} Se conservan historial, notas, tareas y conversaciones.
          </DialogDescription>
        </DialogHeader>
        <Select value={sellerId || undefined} onValueChange={setSellerId}>
          <SelectTrigger className="h-11 rounded-xl" data-testid="reassign-seller-select"><SelectValue placeholder="Selecciona un vendedor" /></SelectTrigger>
          <SelectContent>
            {sellers.map((s) => (
              <SelectItem key={s.id} value={s.id} data-testid={`reassign-option-${s.id}`}>
                {s.name}{!s.active && " (desactivado)"}{s.id === lead.assigned_seller_id && " (actual)"}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        {error && <p className="text-sm text-rose-600" data-testid="reassign-error">{error}</p>}
        <Button onClick={save} disabled={!sellerId || saving} className="rounded-xl bg-[#1E6FD9]" data-testid="reassign-confirm-button">
          {isAssign ? "Asignar" : "Reasignar"}
        </Button>
      </DialogContent>
    </Dialog>
  );
};
